import {injectReducer} from '../../store/reducers'
import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'home',
  onEnter: isLoggedIn(store),
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
     and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      // const HomeView = require('./components/HomeView').default;
      const Home = require('./containers/HomeContainer').default;
      var homeReducers = require('./modules/home');
      const genderOptionsReducer = homeReducers.genderOptionsReducer;
      const filterValuesReducer = homeReducers.filterValuesReducer;
      const loadStoreOptionsReducer = homeReducers.loadStoreOptionsReducer;
      const lineChartDataReducer = require('components/LineChart/reducers');
      const widgetDataReducer = require('components/StatsWidget/reducers').default;
      const campaignReducer = require('routes/Campaign/modules/campaign').default;
      const userReducer = lineChartDataReducer.userReducer;
      // const sbReducer = require('components/SunburstChart/reducers').default;
      // const heatMapReducer = require('components/HeatMap/reducers').default;
      // const handleFilters = require('components/SunburstChart/reducers').handleFilters;

      /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, {key: 'widgetData', reducer: widgetDataReducer});
      injectReducer(store, {key: 'genderOptions', reducer: genderOptionsReducer});
      injectReducer(store, {key: 'filter', reducer: filterValuesReducer});
      injectReducer(store, {key: 'data', reducer: userReducer});
      injectReducer(store, {key: 'campaign', reducer: campaignReducer})
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer})
      // injectReducer(store, { key: 'filter', reducer: handleFilters });
      // injectReducer(store, { key: 'heatMapData', reducer: heatMapReducer });

      /*  Return getComponent   */
      cb(null, Home)

      /* Webpack named bundle   */
    }, 'HomeView')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Home/index.js